import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { LayerPopup, Props as LayerPopupProps } from './LayerPopup'
import { useForestHabitatQuery } from '@foros-fe/graphql'
import { formatArea } from '../../../utils'
import tw from 'tailwind-styled-components'

type Props = Pick<LayerPopupProps, 'position'> & {
  id: string
}

const Line = tw.div`flex gap-4`
const Column = tw.div`flex flex-col justify-between gap-4`

export const ForestHabitatPopup: FC<Props> = ({ position, id }) => {
  const { t } = useTranslation(['forest', 'common', 'enum'])
  const { data } = useForestHabitatQuery({ variables: { id } })

  const forestHabitat = data?.forestHabitat

  return (
    <LayerPopup position={position} layer='forestHabitats' title={t('common:map.forestHabitat')}>
      {forestHabitat ? (
        <Line>
          <Column>
            <LayerPopup.Item label={t('area')} value={formatArea(forestHabitat.area)} />
            {forestHabitat.category ? (
              <LayerPopup.Item
                label={t('forestHabitat.category')}
                value={t(`enum:ForestHabitatCategory.${forestHabitat.category}`)}
              />
            ) : null}
          </Column>
          <Column>
            <LayerPopup.Item
              label={t('forestHabitat.kind')}
              value={t(`enum:ForestHabitatKind.${forestHabitat.kind}`)}
            />
            {forestHabitat.codes.length ? (
              <LayerPopup.Item
                label={t('forestHabitat.codes')}
                value={forestHabitat.codes.join(', ')}
              />
            ) : null}
          </Column>
        </Line>
      ) : null}
    </LayerPopup>
  )
}
